import React, { type ReactNode } from "react";
import { cx } from "components/Graphs/utils";

type InfoBoxVariant = "success" | "info" | "warning" | "error";

interface InfoBoxProps {
  variant: InfoBoxVariant;
  children: ReactNode;
  className?: string;
}

const variantStyles: Record<InfoBoxVariant, string> = {
  success:
    "bg-emerald-50 dark:bg-emerald-400/10 border-emerald-200 dark:border-emerald-400/20",
  info: "bg-secondaryBg dark:bg-secondaryBg border-secondaryBg dark:border-secondaryBg",
  warning: "border-yellow-200 dark:border-yellow-400/20",
  error: "border-red-200 dark:border-red-400/20",
};

export const InfoBox = ({ variant, children, className }: InfoBoxProps) => (
  <div
    className={cx(
      "rounded-lg border p-3 pt-2",
      variantStyles[variant],
      className,
    )}
  >
    {children}
  </div>
);
